import { createSelector } from 'reselect';

import { StateDictionary } from '../reducers/utils/state-manager';

export type CriticalDatesState = {
  criticalDatesByOrgId: { [orgId: number]: { [date: string]: Array<CriticalDate> } };
  criticalDatesStateByOrgId: StateDictionary;
};
type State = { criticalDates: CriticalDatesState };

const criticalDatesByIdSelector = (state: State) => state.criticalDates.criticalDatesByOrgId;
export const criticalDatesForOrgIdSelector = createSelector(
  [criticalDatesByIdSelector, (_state: State, orgId: number) => orgId],
  (criticalDatesByOrgId, orgId) => criticalDatesByOrgId[orgId],
);

const criticalDatesStateByOrgIdSelector = (state: State) =>
  state.criticalDates.criticalDatesStateByOrgId;
export const criticalDatesStateForOrgIdSelector = createSelector(
  [criticalDatesStateByOrgIdSelector, (_state: State, orgId: number) => orgId],
  (criticalDatesStateByOrgId, orgId) => criticalDatesStateByOrgId[orgId],
);
